import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@dg/shared-services';

@Component({
  selector: 'dgx-profile-not-found',
  templateUrl: './profile-not-found.component.html',
  styleUrls: ['./profile-not-found.component.scss'],
})
export class ProfileNotFoundComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  public ngOnInit(): void {
    let url = '/';
    if (this.authService.authUser) {
      url = `/profile/${this.authService.authUser.viewerProfile.vanityUrl}`;
    }
    this.router.navigateByUrl(url, { replaceUrl: true });
  }
}
